function SvgGift({ color = "#1976D2", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#svg_gift_icon_svg)">
        <path
          d="M16.668 10.0013V18.3346H3.33464V10.0013M10.0013 18.3346V5.83464M10.0013 5.83464H6.2513C5.69877 5.83464 5.16886 5.61514 4.77816 5.22444C4.38746 4.83374 4.16797 4.30384 4.16797 3.7513C4.16797 3.19877 4.38746 2.66886 4.77816 2.27816C5.16886 1.88746 5.69877 1.66797 6.2513 1.66797C9.16797 1.66797 10.0013 5.83464 10.0013 5.83464ZM10.0013 5.83464H13.7513C14.3038 5.83464 14.8337 5.61514 15.2244 5.22444C15.6151 4.83374 15.8346 4.30384 15.8346 3.7513C15.8346 3.19877 15.6151 2.66886 15.2244 2.27816C14.8337 1.88746 14.3038 1.66797 13.7513 1.66797C10.8346 1.66797 10.0013 5.83464 10.0013 5.83464ZM1.66797 5.83464H18.3346V10.0013H1.66797V5.83464Z"
          stroke={color || color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="svg_gift_icon_svg">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgGift;
